module.exports = __webpack_public_path__ + "static/img/run2023_mobile.dca50534.jpg";